module.exports = __webpack_public_path__ + "media/images/logo_eim_white-1b16d31e.png";